import { IRoute } from '../../../sp-types/routeType';
import { formatToPriceInDollars } from '../../../utils/FormatValue';
import { getRouteTotalPrice, getRouteTotalCollateral } from '../../../utils/routesUtils';
import { InputRouteDetailsDataBlob } from './components/RouteDetailsDataBlob/InputRouteDetailsDataBlob';
import { RouteDetailsDataBlob } from './components/RouteDetailsDataBlob/RouteDetailsDataBlob';
import { InputRouteDetailsDataBlobPreset } from './components/RouteDetailsDataBlob/RouteDetailsDataBlobPreset/InputRouteDetailsDataBlobPreset';
import { RouteDetailsDataBlobPreset } from './components/RouteDetailsDataBlob/RouteDetailsDataBlobPreset/RouteDetailsDataBlobPreset';
import { InputRouteDetailsImage } from './components/RouteDetailsImage/InputRouteDetailsImage';
import { RouteDetailsImage } from './components/RouteDetailsImage/RouteDetailsImage';
import { InputRouteDetailsKeyValue } from './components/RouteDetailsKeyValue/InputRouteDetailsKeyValue';
import { RouteDetailsKeyValue } from './components/RouteDetailsKeyValue/RouteDetailsKeyValue';
import { InputRouteDetailsPlainText } from './components/RouteDetailsPlainText/InputRouteDetailsPlainText';
import { RouteDetailsPlainText } from './components/RouteDetailsPlainText/RouteDetailsPlainText';
import { InputRouteDetailsSubTitle } from './components/RouteDetailsSubTitle/InputRouteDetailsSubTitle';
import { RouteDetailsSubTitle } from './components/RouteDetailsSubTitle/RouteDetailsSubTitle';
import { InputRouteDetailsTable } from './components/RouteDetailsTable/InputRouteDetailsTable';
import { RouteDetailsTable } from './components/RouteDetailsTable/RouteDetailsTable';
import { InputRouteDetailsTextBox } from './components/RouteDetailsTextBox/InputRouteDetailsTextBox';
import { RouteDetailsTextBox } from './components/RouteDetailsTextBox/RouteDetailsTextBox';
import { InputRouteMainTitle } from './components/RouteMainTitle/InputRouteMainTitle';
import { RouteMainTitle } from './components/RouteMainTitle/RouteMainTitle';
import { IDataBlobDictionaryType, IRouteDetailsDictionaryItem } from '../../../sp-types/routeDetailsType';

export const DataBlobPresetTypes: Record<string, IDataBlobDictionaryType> = {
  'price-main-price': {
    title: '',
    icon: 'location',
    isAlert: false,
    getDataList: (route: IRoute) => [
      { title: 'Price', value: formatToPriceInDollars(getRouteTotalPrice(route.prices)) },
      { title: 'Collateral', value: formatToPriceInDollars(getRouteTotalCollateral(route.prices)) },
    ],
  },
  'price-transactions': {
    title: 'Transaction fees',
    icon: 'location',
    isAlert: false,
    getDataList: (route: IRoute) => [
      { title: 'Price', value: formatToPriceInDollars(route.prices.transactionFees.price) },
      { title: 'Collateral', value: formatToPriceInDollars(route.prices.transactionFees.collateral) },
    ],
  },
  'price-shipping': {
    title: 'Shipping',
    icon: 'location',
    isAlert: false,
    getDataList: (route: IRoute) => [
      { title: 'Price', value: formatToPriceInDollars(route.prices.shipping.price) },
      { title: 'Collateral', value: formatToPriceInDollars(route.prices.shipping.collateral) },
    ],
  },
  'price-currency': {
    title: 'Currency',
    icon: 'location',
    isAlert: false,
    getDataList: (route: IRoute) => [
      { title: 'Price', value: formatToPriceInDollars(route.prices.currency.price) },
      { title: 'Collateral', value: formatToPriceInDollars(route.prices.currency.collateral) },
    ],
  },
  'price-total': {
    title: 'total',
    icon: 'location',
    isAlert: true,
    getDataList: (route: IRoute) => [
      { title: 'Price', value: formatToPriceInDollars(getRouteTotalPrice(route.prices)) },
    ],
  },
  'risk-overall': {
    title: 'Overall risk',
    icon: 'risk',
    isAlert: true,
    getDataList: (route: IRoute) => [{ value: route.risk.overall.toString() }],
  },
  'risk-price': {
    title: 'Price risk',
    icon: 'risk',
    isAlert: false,
    getDataList: (route: IRoute) => [{ value: route.risk.price.toString() }],
  },
  'risk-operational': {
    title: 'Operational risk',
    icon: 'risk',
    isAlert: false,
    getDataList: (route: IRoute) => [{ value: route.risk.operational.toString() }],
  },
  'risk-counterparty': {
    title: 'Counterparty risk',
    icon: 'risk',
    isAlert: false,
    getDataList: (route: IRoute) => [{ value: route.risk.counterParty.toString() }],
  },
};
export const routeDetailsIcons: Record<string, string> = {
  route: '/assets/icons/gray-bg/route.svg',
  risk: '/assets/icons/gray-bg/risk.svg',
  techSpec: '/assets/icons/gray-bg/route.svg',
  gear: '/assets/icons/gray-bg/route.svg',
  location: '/assets/icons/gray-bg/location.svg',
  quantity: '/assets/icons/gray-bg/route.svg',
  units: '/assets/icons/gray-bg/route.svg',
};

export const RouteDetailsComponentMap: Record<string, IRouteDetailsDictionaryItem<any>> = {
  RouteMainTitle: {
    component: RouteMainTitle,
    inputComponent: InputRouteMainTitle,
    defaultValue: {
      title: 'Default Title',
      text: 'Default Text',
    },
  },
  RouteDetailsDataBlob: {
    component: RouteDetailsDataBlob,
    inputComponent: InputRouteDetailsDataBlob,
    defaultValue: {
      icon: 'default-icon',
      title: 'Default Title',
      dataList: [{ title: 'Default Data Title', value: 'Default Value' }],
      isAlert: false,
    },
  },
  RouteDetailsDataBlobPreset: {
    component: RouteDetailsDataBlobPreset,
    inputComponent: InputRouteDetailsDataBlobPreset,
    defaultValue: {
      currentType: '',
    },
  },
  RouteDetailsPlainText: {
    component: RouteDetailsPlainText,
    inputComponent: InputRouteDetailsPlainText,
    defaultValue: {
      text: 'Default Plain Text',
    },
  },
  RouteDetailsTextBox: {
    component: RouteDetailsTextBox,
    inputComponent: InputRouteDetailsTextBox,
    defaultValue: {
      text: 'Default Text Box Text',
    },
  },
  RouteDetailsKeyValue: {
    component: RouteDetailsKeyValue,
    inputComponent: InputRouteDetailsKeyValue,
    defaultValue: {
      data: [{ label: 'Default Label', value: 'Default Value' }],
    },
  },
  RouteDetailsSubTitle: {
    component: RouteDetailsSubTitle,
    inputComponent: InputRouteDetailsSubTitle,
    defaultValue: {
      title: 'Default SubTitle',
      icon: 'default-icon',
    },
  },
  RouteDetailsTable: {
    component: RouteDetailsTable,
    inputComponent: InputRouteDetailsTable,
    defaultValue: {
      columns: ['Default Column'],
      rowsData: [{ 'Default Column': 'Default Row Data' }],
    },
  },
  RouteDetailImage: {
    component: RouteDetailsImage,
    inputComponent: InputRouteDetailsImage,
    defaultValue: {
      imageUrl: '',
      routeId: '',
    },
  },
};
